export const COLOR = {
  primary: '#003960',
  secondary: '#efa420',
  secondaryLight: '#ffcb05',
}
